import { useState } from "react";
import { CiSearch } from "react-icons/ci";

export default function SearchBar({ onSearch, onClear }) {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = () => {
    if (onSearch && searchTerm.trim()) {
      onSearch(searchTerm.trim());
    }
  };

  const handleClear = () => {
    setSearchTerm(""); // Clear the local state
    if (onClear) onClear(); // Trigger the onClear function passed as a prop
  };

  return (
    <div className="flex items-center bg-white border border-gray-300 rounded-md shadow-sm px-4 py-2 w-full max-w-md">
      <CiSearch />

      <input
        type="text"
        className="flex-grow px-2 text-gray-700 focus:outline-none"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleSearch()}
      />
      <button
        onClick={handleSearch}
        className="ml-2 bg-orange-400 text-white px-4 py-2 rounded-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500"
      >
        Search
      </button>
      <button
        onClick={handleClear}
        className="ml-2 bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-500"
      >
        Clear
      </button>
    </div>
  );
}
